import { api } from "@/lib/api";

const b64ToBytes = (v) => {
  const raw = atob((v + "=".repeat((4 - (v.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
export const isInstalled = () => window.matchMedia?.("(display-mode: standalone)").matches || navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// "ios-install" | "unsupported" | "denied" | "on" | "off"
export const pushStatus = async () => {
  if (!pushSupported()) return isIOS() && !isInstalled() ? "ios-install" : "unsupported";
  if (Notification.permission === "denied") return "denied";
  const reg = await navigator.serviceWorker.getRegistration("/");
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub && Notification.permission === "granted" ? "on" : "off";
};

// Must be called straight from a tap
export const turnOnPush = async () => {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error(perm === "denied" ? "Notifications are blocked in your phone's settings" : "Notifications weren't allowed");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { key } = await api.pushKey();
  let sub;
  try {
    sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(key) }));
  } catch {
    throw new Error(isIOS() ? "Couldn't turn on notifications — open the Bucketlist from your Home Screen and try again" : "This browser couldn't turn on notifications — try Chrome or Safari");
  }
  await api.pushSubscribe(sub.toJSON());
};

export const turnOffPush = async () => {
  const reg = await navigator.serviceWorker.getRegistration("/");
  const sub = reg && (await reg.pushManager.getSubscription());
  if (!sub) return;
  await api.pushUnsubscribe(sub.endpoint).catch(() => null);
  await sub.unsubscribe();
};
